export const TypeFacturation = ['Facture', 'RemboursementProforma', 'Remboursement', 'Avoir'] as const
export type TypeFacturation = typeof TypeFacturation[number]

export const TypeFacturationLibelle: Record<TypeFacturation, string> = {
  Facture: 'Facture',
  RemboursementProforma: 'DR/Proforma',
  Remboursement: 'DR',
  Avoir: 'Annulation/Avoir',
}
